/**
 * Created by jayed.talukder on 9/13/2018.
 */

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType} from '@ngrx/effects';

import { switchMap, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {Observable} from 'rxjs';
import { FieldDefinationsResponseModel } from '@shared/models/field-defination-response.model';
import { PagedResponse } from '@shared/models/paged-response-model';
import { CommandService } from '@core/services/command.service';
import { GraphQLService } from '@core/services/graphql.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import {EntityChartApiService} from '../../../entity-chart/services/entity-chart-service';
import { PaymentStreamSetting } from '../../../models/payment-stream-setting.model';
import {TransactionService} from '../../services/transaction.service';
import {
  ADD_TRANSACTION, CREATE_TRANSACTION_BETWEEN_MY_COUNTRIES, CreateTransactionsBetweenMyCountriesAction,
  CreateTransactionsBetweenMyCountriesFailedAction, CreateTransactionsBetweenMyCountriesSuccessAction,
  DELETE_ALL_TRANSACTION, DELETE_TRANSACTION, DeleteAllTransactionsAction, DeleteAllTransactionsFailedAction,
  DeleteAllTransactionsSuccessAction, FETCH_ALL_PAYING_ENTITIES, FETCH_ALL_RECEIVING_ENTITIES, FETCH_ALL_STREAMS,
  FETCH_RECEIVING_ENTITIES,
  FetchAllPayingEntitiesAction,
  FetchAllPayingEntitiesActionFailed, FetchAllReceivingEntitiesActionFailed, FetchAllStreamsActionFailed,
  FetchReceivingEntitiesAction,
  FetchReceivingEntitiesActionFailed,
  GET_RECEIVING_ENTITIES_STREAMS, GET_STREAMS, GET_TRANSACTION_FIELD_DEFINATIONS, GET_TRANSACTIONS,
  GetReceivingEntitiesStreamsAction, GetStreamsAction, GetStreamsActionFailed, GetStreamsActionSuccess,
  GetTransactionFieldDefinationsAction, GetTransactionFieldDefinationsFailedAction,
  GetTransactionFieldDefinationsSuccessAction, GetTransactionsAction, GetTransactionsFailedAction,
  GetTransactionsSuccessAction, RESET_TRANSACTIONS_FROM_PROJECT_SETTINGS, ResetTransactionsFromProjectSettingsAction,
  ResetTransactionsFromProjectSettingsFailedAction, ResetTransactionsFromProjectSettingsSuccessAction,
  SetPayingEntitiesAction, SetReceivingEntitiesAction, TransactionAddAction, TransactionAddActionFailed,
  TransactionAddActionSuccess, TransactionDeleteAction, TransactionDeleteActionFailed
} from '../actions/transaction.actions';
import {EntitySetting} from '../../../models/entity-setting.model';
import {InvalidateSmartGridAction} from "@shared/store/actions/smart-grid.actions";


@Injectable()
export class TransactionEffects {
  constructor (private actions$: Actions,
               private entityService: EntityChartApiService,
               private backendApi: TransactionService,
               private commandService: CommandService,
               private snackBarService: SnackBarService,
               private fuseSplashScreenService: FuseSplashScreenService,
               private graphqlService: GraphQLService) {
  }


  allPayingEntitiesDataFetch = createEffect(() => this.actions$
    .pipe( ofType(FETCH_ALL_PAYING_ENTITIES) )
    .pipe(
      mergeMap((action) => {
        this.fuseSplashScreenService.show();
        return this.backendApi.getAllPayingEntities().pipe(
          map((payload: EntitySetting[]) => {
            this.fuseSplashScreenService.hide();
            return new SetPayingEntitiesAction(payload);
          }),
          catchError((error, caught) => {
            this.fuseSplashScreenService.hide();
            return of(new FetchAllPayingEntitiesActionFailed(error));
          })
        );
      })
    ));


  allReceivingEntitiesDataFetch = createEffect(() => this.actions$
    .pipe( ofType(FETCH_ALL_RECEIVING_ENTITIES) )
    .pipe(
      mergeMap((action) => {
        this.fuseSplashScreenService.show();
        return this.backendApi.getAllReceivingEntities().pipe(
          map((payload: EntitySetting[]) => {
            this.fuseSplashScreenService.hide();
            return new SetReceivingEntitiesAction(payload);
          }),
          catchError((error, caught) => {
            this.fuseSplashScreenService.hide();
            return of(new FetchAllReceivingEntitiesActionFailed(error));
          })
        );
      })
    ));


  allStreamsDataFetch = createEffect(() => this.actions$
    .pipe( ofType(FETCH_ALL_STREAMS) )
    .pipe(
      mergeMap((action) => {
        this.fuseSplashScreenService.show();
        return this.backendApi.getAllStreams().pipe(
          map((payload: PaymentStreamSetting[]) => {
            this.fuseSplashScreenService.hide();
            return new GetStreamsActionSuccess(payload);
          }),
          catchError((error, caught) => {
            this.fuseSplashScreenService.hide();
            return of(new FetchAllStreamsActionFailed(error));
          })
        );
      })
    ));

  receivingEntitiesDataFetch = createEffect(() => this.actions$
    .pipe( ofType(FETCH_RECEIVING_ENTITIES) )
    .pipe(
      mergeMap((action) => {
        this.fuseSplashScreenService.show();
        return this.backendApi.getReceivingEntities((action as FetchReceivingEntitiesAction).payload).pipe(
          map((payload: EntitySetting[]) => {
            this.fuseSplashScreenService.hide();
            return new SetReceivingEntitiesAction(payload);
          }),
          catchError((error, caught) => {
            this.fuseSplashScreenService.hide();
            return of(new FetchReceivingEntitiesActionFailed(error));
          })
        );
      })
    ));


  streamsDataFetch = createEffect(() => this.actions$
    .pipe( ofType(GET_STREAMS) )
    .pipe(
      mergeMap((action) => {
        this.fuseSplashScreenService.show();
        return this.backendApi.getStreams((action as GetStreamsAction).payingEntity, (action as GetStreamsAction).receivingEntity).pipe(
          map((payload: PaymentStreamSetting[]) => {
            this.fuseSplashScreenService.hide();
            return new GetStreamsActionSuccess(payload);
          }),
          catchError((error, caught) => {
            this.fuseSplashScreenService.hide();
            return of(new GetStreamsActionFailed(error));
          })
        );
      })
    ));


  transactionAdd = createEffect(() => this.actions$
    .pipe( ofType(ADD_TRANSACTION) )
    .pipe(
      mergeMap((action: TransactionAddAction) => {
        this.fuseSplashScreenService.show();
        return this.commandService.executeCommand(action.command)
          .pipe(
            mergeMap((payload: any) => {
              this.fuseSplashScreenService.hide();
              this.snackBarService.showInformation('Transaction Added.');
              return [new TransactionAddActionSuccess(payload),
                new GetTransactionsAction(),
                new InvalidateSmartGridAction(action.sourceType, true, true, true)];
            }),
            catchError((error, caught) => {
              this.fuseSplashScreenService.hide();
              return of(new TransactionAddActionFailed(error));
            })
          );
      })
    ));


  transactionDelete = createEffect(() => this.actions$
    .pipe( ofType(DELETE_TRANSACTION) )
    .pipe(
      mergeMap((action: TransactionDeleteAction) => {
        this.fuseSplashScreenService.show();
        return this.commandService.executeCommand(action.command)
          .pipe(
            mergeMap((payload: any) => {
              const allActions = action.command.transactions.map(transaction => [
                new FetchAllPayingEntitiesAction(),
                new FetchReceivingEntitiesAction(transaction.payingEntity.id),
                new GetStreamsAction(transaction.payingEntity.id, transaction.receivingEntity.id),
                new GetTransactionsAction(),
                new InvalidateSmartGridAction(action.sourceType, true, true, true)
              ]).reduce((previous, current) => previous.concat(current));
              this.fuseSplashScreenService.hide();
              this.snackBarService.showInformation('Transaction Deleted.');
              return allActions;
            }),
            catchError((error, caught) => {
              this.fuseSplashScreenService.hide();
              return of(new TransactionDeleteActionFailed(error));
            })
          );
      })
    ));



  GetTransactions = createEffect(() => this.actions$
    .pipe( ofType(GET_TRANSACTIONS) )
    .pipe(
      mergeMap((action: GetTransactionsAction) => {
        this.fuseSplashScreenService.show();
        return this.backendApi.getTransactions(action.pageNo, action.pageSize).pipe(
          map((payload: PagedResponse) => {
            this.fuseSplashScreenService.hide();
            return new GetTransactionsSuccessAction(payload);
          }),
          catchError(error => {
            this.fuseSplashScreenService.hide();
            return of(new GetTransactionsFailedAction(error));
          })
        );
      })
    ));


  GetTransactionFieldSections$ = createEffect(() => this.actions$
    .pipe( ofType(GET_TRANSACTION_FIELD_DEFINATIONS) )
    .pipe(
      mergeMap((action: GetTransactionFieldDefinationsAction) => {
        this.fuseSplashScreenService.show();
        return this.graphqlService.executePostRequest(action.apiKey, action.query)
          .pipe(
            map((payload: FieldDefinationsResponseModel) => {
              this.fuseSplashScreenService.hide();
              return new GetTransactionFieldDefinationsSuccessAction(payload.data.fieldDefinitions);
            }),
            catchError(error => {
              this.fuseSplashScreenService.hide();
              return of(new GetTransactionFieldDefinationsFailedAction(error));
            })
          );
      })
    ));

  getReceivingEntitiesStreams = createEffect(() => this.actions$
    .pipe( ofType(GET_RECEIVING_ENTITIES_STREAMS) )
    .pipe(
      mergeMap((action: GetReceivingEntitiesStreamsAction) => {
        this.fuseSplashScreenService.show();
        return this.backendApi.getReceivingEntities(action.payingEntityId)
          .pipe(
            mergeMap((payloadForReceivingEntities: EntitySetting[]) =>
              this.backendApi.getStreams(action.payingEntityId, action.receivingEntityId).pipe(
                mergeMap((payloadForStreams: PaymentStreamSetting[]) => {
                  this.fuseSplashScreenService.hide();
                  return [new SetReceivingEntitiesAction(payloadForReceivingEntities),
                    new GetStreamsActionSuccess(payloadForStreams)];
                }),
                catchError((error, caught) => {
                  this.fuseSplashScreenService.hide();
                  return of(new FetchReceivingEntitiesActionFailed(error));
                })
              ))
          );
      })
    ));


  resetTransactionsFromProjectSettings= createEffect(() => this.actions$
    .pipe( ofType(RESET_TRANSACTIONS_FROM_PROJECT_SETTINGS) )
    .pipe(
      mergeMap((action: ResetTransactionsFromProjectSettingsAction) => {
          this.fuseSplashScreenService.show();
          return this.commandService.executeCommand(action.command)
            .pipe(
              mergeMap((payload: any) => {
                this.snackBarService.showInformation('Transactions Reset from Project Settings.');
                this.fuseSplashScreenService.hide();
                return [
                  new FetchAllPayingEntitiesAction(),
                  new GetTransactionsAction(),
                  new ResetTransactionsFromProjectSettingsSuccessAction(payload),
                  new InvalidateSmartGridAction(action.sourceType, true, true, true)
                ];
              }),
              catchError((error) => {
                this.snackBarService.showError('Transactions Reset from Project Settings Failed');
                this.fuseSplashScreenService.hide();
                return of(new ResetTransactionsFromProjectSettingsFailedAction(error));
              })
            );
        }
      )
    ));


  createTransactionsBetweenMyCountries = createEffect(() => this.actions$
    .pipe( ofType(CREATE_TRANSACTION_BETWEEN_MY_COUNTRIES) )
    .pipe(
      mergeMap((action: CreateTransactionsBetweenMyCountriesAction) => {
          this.fuseSplashScreenService.show();
          return this.commandService.executeCommand(action.command)
            .pipe(
              mergeMap((payload: any) => {
                this.snackBarService.showInformation('Transaction Created.');
                this.fuseSplashScreenService.hide();
                return [
                  new FetchAllPayingEntitiesAction(),
                  new GetTransactionsAction(),
                  new CreateTransactionsBetweenMyCountriesSuccessAction(payload),
                  new InvalidateSmartGridAction(action.sourceType, true, true, true)
                ];
              }),
              catchError((error) => {
                this.snackBarService.showError('Create transactions between my countries failed');
                this.fuseSplashScreenService.hide();
                return of(new CreateTransactionsBetweenMyCountriesFailedAction(error));
              })
            );
        }
      )
    ));


  deleteAllTransactions = createEffect(() => this.actions$
    .pipe( ofType(DELETE_ALL_TRANSACTION) )
    .pipe(
      mergeMap((action: DeleteAllTransactionsAction) => {
          this.fuseSplashScreenService.show();
          return this.commandService.executeCommand(action.command)
            .pipe(
              mergeMap((payload: any) => {
                this.snackBarService.showInformation('Transactions Cleared.');
                this.fuseSplashScreenService.hide();
                return [
                  new FetchAllPayingEntitiesAction(),
                  new GetTransactionsAction(),
                  new DeleteAllTransactionsSuccessAction(payload),
                  new InvalidateSmartGridAction(action.sourceType, true, true, true)
                ];
              }),
              catchError((error) => {
                this.snackBarService.showError('Delete all transactions failed');
                this.fuseSplashScreenService.hide();
                return of(new DeleteAllTransactionsFailedAction(error));
              })
            );
        }
      )
    ));
}
